<script lang="ts" setup>
defineProps<{
  title: string;
}>();
</script>

<template>
  <div class="dashboard-header">
    <div class="d-flex align-items-center justify-content-between">
      <h2 class="h3">{{ title }}</h2>
      <div class="d-flex gap-2">
        <slot name="actions" />
      </div>
    </div>
  </div>
  <hr/>
</template>

<style lang="scss" scoped>
</style>